import { compose } from 'redux';
import { SERVICE_NAME } from '../constants';
import {
  useDebugMode,
  setLocalGameLaunchMode,
} from './actions/app/initialization';

const devtoolsExtensionConfig = {
  name: `${SERVICE_NAME}/${window.location.hostname}`,
  actionCreators: {
    useDebug: useDebugMode,
    useLocalGameLaunchMode: setLocalGameLaunchMode,
  },
};

/**
 * Enable redux-devtools extension for Chrome
 */
export const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(devtoolsExtensionConfig)
  : compose;
